import { useState, useEffect } from "react";
import Image from "../../models/Image";
import ImagesService from "../../services/crud/ImageService";
import { Form, FormInstance, Input, Upload, Image as AntImage, Spin, Tooltip } from "antd";
import { LoadingOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { LangKeyList } from "../../models/LangKey";
import { LocalizedField } from "./inputs/LocalizedField";

export const ImageForm = ({id, form, onSelectFile}: {id?: number|string, form: FormInstance, onSelectFile?: (file: File) => void}) => {
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState<string>(undefined);

  useEffect(() => {
    form.resetFields();
    if (id) {
      setLoading(true);
      ImagesService.getImage(id).then((data) => {
        setLoading(false);

        const formData = {
          id: id,
          name: data.name,
          alt: data.alt ? JSON.parse(data.alt) : {},
          file: '',
        }
        setPreviewUrl(undefined);

        form.setFieldsValue(formData);
      });
    }

    // Load data
  }, [form, id]);

  if (loading) {
    return <></>;
  }

  function nameFromFilename(filename: string): string {
    const lastDot = filename.lastIndexOf(".");
    return lastDot > 0 ? filename.slice(0, lastDot) : filename;
  }

  function handleChangeFile(event) {
    const file: File = event.target.files[0];
    if (onSelectFile) {
      onSelectFile(file);
    }
    form.setFieldValue('file', file);
    setPreviewUrl(URL.createObjectURL(file));
    const oldName = form.getFieldValue('name');
    if (oldName === undefined || oldName === '') {
      form.setFieldValue('name', nameFromFilename(file.name));
    }
  }

  const content = (
    <Form<Image> form={form}>
      <Form.Item noStyle name="id">
        <Input type="hidden" />
      </Form.Item>

      <Form.Item label="Image" name="file" required={!id} rules={[{ required: !id }]}>
        <Input type="file" accept={".png,.avif,.jpeg,.jpg,.webp"} onChange={handleChangeFile} />
        { previewUrl && (
          <div style={{marginTop: 10}}>
          <AntImage src={previewUrl} style={{maxHeight: 300}} />
          </div>
        )}
      </Form.Item>

      <Form.Item label="Name" name="name" required rules={[{ required: true }]}>
        <Input maxLength={32} />
      </Form.Item>

      <LocalizedField
        supportedLanguages={LangKeyList}
        name="alt"
        inputType="input"
        label="Alt text"
        placeholder=" "
        minLabelWidth={20}
      />
    </Form>
  );

  if (loading) {
    return (
      <Spin size="large" tip="Loading" indicator={<LoadingOutlined />}>
        {content}
      </Spin>
    );
  }
  return content;
};

